"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCheckIsOpenCloseMode = exports.usePositionMode = exports.getPositionModeObservable = void 0;
const react_1 = require("react");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const trade_utils_lib_1 = require("trade_utils_lib");
const FutureAPI_1 = require("../../../apis/FutureAPI");
const interface_1 = require("../../../interface");
const errors_1 = require("../../../interface/errors");
const CustomAssetsProvider_1 = require("../CustomAssetsProvider");
const CustomOrders_1 = require("../../../component/CustomOrders");
function getPositionModeObservable() {
    return (0, CustomAssetsProvider_1.getCustomAssetsObservable)().pipe((0, operators_1.map)((data) => data.positionMode));
}
exports.getPositionModeObservable = getPositionModeObservable;
/**获取仓位模式 */
function usePositionMode(accountType, isActive = true) {
    const assetsData = (0, CustomAssetsProvider_1.useCustomAssets)(accountType, isActive);
    const positionMode = assetsData.positionMode;
    const hasPosition = assetsData.hasPositions;
    const changeModeAction = (0, react_1.useCallback)((mode) => {
        if (mode === positionMode) {
            return (0, rxjs_1.of)(true);
        }
        if (hasPosition) {
            return (0, rxjs_1.throwError)(errors_1.TRADE_CHANGED_POSITION_MODE_FAILURE);
        }
        return (0, CustomOrders_1.checkActiveOrder)(trade_utils_lib_1.AccountTradeType.trader).pipe((0, operators_1.mergeMap)((hasOrders) => {
            if (hasOrders) {
                return (0, rxjs_1.throwError)(errors_1.TRADE_CHANGED_POSITION_MODE_FAILURE);
            }
            return (0, rxjs_1.of)(false);
        }), (0, operators_1.mergeMap)(() => (0, FutureAPI_1.setPositionModeApi)(mode)), (0, operators_1.mergeMap)(() => {
            // refresh account
            // 刷新接口，重新获取仓位模式
            (0, CustomAssetsProvider_1.refreshAccountDetail)();
            return (0, rxjs_1.of)(true);
        }));
    }, [hasPosition, positionMode]);
    const changePositionMode = (0, react_1.useCallback)((mode) => {
        return changeModeAction(mode).pipe((0, operators_1.catchError)((err) => (0, rxjs_1.throwError)((0, trade_utils_lib_1.getTradeDependencyInstance)().localizeError(err))));
    }, [changeModeAction]);
    return {
        /**获取当前仓位模式 */
        positionMode,
        /**更新仓位模式，对应错误码为0025100007 */
        setPositionMode: changePositionMode,
    };
}
exports.usePositionMode = usePositionMode;
/**检测是否是双向持仓 */
function useCheckIsOpenCloseMode(accountType, isActive = true) {
    const { positionMode } = usePositionMode(accountType, isActive);
    return positionMode === interface_1.OrderPositionMode.OPENCLOSE;
}
exports.useCheckIsOpenCloseMode = useCheckIsOpenCloseMode;
